import { gql } from "@apollo/client";

export const RESET = gql`
  mutation {
    reset
  }
`;
